<template>
<div class='page-start'>
	<mdb-container class="pb-3" fluid>

        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
            Success! Submitted Support Ticket!
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
            {{ this.errorMsg }}.
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
					There was an error uploading the file(s). The ticket was submitted without the file(s). Error Code P4
				</mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5" @closeAlert="p5=false" dismiss>
					There was an error loading ticket data. Error Code P5
				</mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
          There was an error retrieving data from the server! Please try again later.
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="wrongFile" @closeAlert="wrongFile=false" dismiss>
          Only image, docx, pdf, and txt files are accepted.
        </mdb-alert>

        <!-- User Feedback and Error Code Displays -->

        <!-- END User Feedback and Error Code Displays -->

        <!-- Create Ticket Table -->
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Submit Support Ticket</h3>
        <mdb-card-body>
            <form @submit.prevent="" class="was-validated">
                <mdb-row>
                  <mdb-col>
                      <mdb-select id="issueDrop" :class="{'is-invalid': !issue,'is-valid': issue}" class="mb-3" v-model="issueOptions" @getValue="setIssue" label="Issue" />
                      <div v-if="!issue" class="invalid-feedback d-block">
                        Please select an option.
                      </div>
                      <div v-else class="valid-feedback d-block">
                        Looks Good!
                      </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                    <mdb-col>
                      <mdb-input label="Description" v-model="description" required outline type='textarea' 
                      :rows="4" invalid-feedback="Please Input Ticket Description" valid-feedback="Looks Good!" maxlength="500"/>
                    </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col>
                    <mdb-file-input :key="uploaderKey" ref="fileupload" @getValue="getImages"
                      sm btn-title='ADD FILES' btnColor='blue' multiple accept="image/*,.docx,.txt,application/pdf"/>
                  </mdb-col>
                </mdb-row>
                 <mdb-row>
                  <mdb-col class="text-left">
                      <p>Image, docx, pdf, and txt file types only</p>
                  </mdb-col>
                </mdb-row><br>
                <mdb-row>
                    <mdb-col>
                        <mdb-input v-model="dateOpenedDisplay" label='Date Opened' id="dateOpened" title='Date Opened' required disabled />
                    </mdb-col>
                </mdb-row>
                    <mdb-row>
                    <mdb-col>
                        <mdb-input label="Name of Submitter" v-model="nameSubmit" required disabled />
                    </mdb-col>
                    <mdb-col>
                        <mdb-input label="Email of Submitter" v-model="emailSubmit" required disabled/>
                    </mdb-col>
                </mdb-row>
                <br>
                <!--<mdb-btn id="submitAddTicket" class='QuadrusButton' size="lg" v-on:click="submitTicket" :disabled="description == '' ">Submit</mdb-btn>-->
                <mdb-btn class="mt-4 QuadrusButton" type="submit" v-on:click="submitTicket" v-if="!submitProcessing">Submit</mdb-btn>
                <mdb-btn class="mt-4 QuadrusButton" v-if="submitProcessing">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </mdb-btn>
                <br>
            </form>
        </mdb-card-body>
        </mdb-card>

        <div ref="ticketStatus">
          <mdb-card class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Ticket Status</h3>
          <mdb-card-body>
            <mdb-input class="mb-0 mt-2" type="checkbox" id="showResolved" name="showResolved" v-model="showResolved" label="Show Resolved"/>
            <QDataTable id='ticketTable' :rowData="this.ticketData.rowData" :filterWords="this.ticketData.filterWords" :headers="this.ticketData.columns"
            :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
            <div :class="{'hideSpinner': isSetUp}" class="p-4">
              <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-container>
</div>
</template>

<script>
import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbBtn, mdbRow, mdbCol, mdbAlert, mdbSelect, mdbFileInput } from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import QDataTable from '@/components/QDataTable.vue';
import * as sendEmail from '@/assets/js/email.js';
import imageCompression from 'browser-image-compression';
import { formatDate } from '@/assets/js/formatDate.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'Submit-IT-Tickets',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbAlert,
    QDataTable,
    mdbSelect,
    mdbFileInput
  },
    
  data() {
    return {
      uploaderKey: 0,
      p1: false,
      p2: false,
      p4: false,
      p5: false,
      p6: false,
      isSetUp: false,
      issueOptions: [{text: "Hardware", value: "Hardware"}, {text: "Network & Connectivity", value: "Network & Connectivity"},
        {text: "Software & Applications", value: "Software & Applications"}, {text: "Access & Security", value: "Access & Security"}, 
        {text: "Email & Communication", value: "Email & Communication"}, {text: "File & Data Management", value: "File & Data Management"}, 
        {text: "System Performance", value: "System Performance"},{text: "Requests & Setup", value: "Requests & Setup"},{text: "Other / Miscellaneous", value: "Other / Miscellaneous"}
      ],
      issue: '',
      imagesOfIssue: [],

      submitProcessing: false,
      errorMsg: '',

      description: '',
      dateOpened: '',
      dateOpenedDisplay: '',
      nameSubmit: '',
      emailSubmit: '',
      wrongFile: false,

      msgIds: [],

      showResolved: false,

      ticketData: {
            columns: [  
              {
                colTitle: 'Ticket Number',
                sortBy: 'id'
              },
              {
                colTitle: 'Date Opened',
                sortBy: 'openDateDisplay'
              },
              {
                colTitle: 'Subject',
                sortBy: 'subject'
              },
              {
                colTitle: 'Priority',
                sortBy: 'priority'
              },
              {
                colTitle: 'Resolved',
                sortBy: 'resolved'
              },
              {
                colTitle: 'Assigned To',
                sortBy: 'assignedTo'
              },
              {
                colTitle: 'Description',
                sortBy: 'description'
              }
            ],
            rowData: [],
            filterWords: [
              'id',
              'openDateDisplay',
              'subject',
              'priority',
              'resolved',
              'assignedTo',
              'description'
            ]
        }
    }
  },

  methods: {

    resetData: function(){
      this.description = "";
      this.imagesOfIssue = [];
      this.issueOptions = [...this.issueOptions];
      this.uploaderKey++;
      this.$refs.fileupload.$el.querySelector('input').value = null;
    },

    getImages: function(value){
      if(value.length > 0){this.imagesOfIssue = [];}
      for(var i = 0; i < value.length; i++){
        if(value[i].type && (value[i].type.includes('image/') || value[i].name.includes('.docx') 
          || value[i].name.includes('.txt') || value[i].name.includes('.pdf'))){
          this.imagesOfIssue.push(value[i]);
        } else {
          // Reject the file
          this.wrongFile = true;
          this.uploaderKey++;
          this.imagesOfIssue = [];
          return;
        }
      }
    },
    resizeImage: async function(file) {
      const options = {
        maxSizeMB: 0.5,            // ~500 KB
        maxWidthOrHeight: 1280,
        useWebWorker: true,
        initialQuality: 0.75
      };

      return await imageCompression(file, options);
    },

    getLoggedInUser: async function () {
      let token = this.$store.getters.getToken;      
      try 
			{
				let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
				let tempFName = response.data.firstName;
				let tempLName = response.data.lastName;

				return tempFName + " " + tempLName;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}
    },

    submitTicket: async function () {
      this.submitProcessing = true;

      try {
        const token = this.$store.getters.getToken;

        // Sanitize content
        this.description = sanitizeInput(this.description, this.$sanitize);
        this.nameSubmit = await this.getLoggedInUser();
        this.emailSubmit = sanitizeInput(this.emailSubmit, this.$sanitize);
        this.issue = sanitizeInput(this.issue, this.$sanitize);
        const issue = this.issue;
        const description = this.description;

        // Required fields check
        if (!this.issue || !this.description) {
          this.p2 = true;
          this.errorMsg = 'Please fill out all required fields';
          return;
        }

        // ---- Step 1: Upload images (optional) ----
        let fileIds = [];
        if (this.imagesOfIssue?.length) {
          try {
            const formData = new FormData();
            for (const file of this.imagesOfIssue) {
              let compressed = file;
              if(file.type.includes("image")){
                compressed = await this.resizeImage(file);
              }
              formData.append(
                'files',
                compressed,
                `${this.nameSubmit}_${this.dateOpened}_${compressed.name}`
              );
            }

            const response = await DatabaseLib.postRequest(
              'strapiDatabase',
              'upload',
              token,
              formData
            );

            fileIds = response.data.map(f => f.id);
          } catch (err) {
            console.error("File upload failed, continuing without files", err);
            this.p4 = true;
          }
        }

        // ---- Step 2: Create ticket ----
        const ticketData = {
          data: {
            issue: this.issue,
            description: this.description,
            openDate: this.dateOpened,
            nameSubmit: this.nameSubmit,
            emailSubmit: this.emailSubmit,
            queued: false,
            resolved: false,
            imagesOfIssue: fileIds
          }
        };

        let ticketSubmission;
        try {
          ticketSubmission = await DatabaseLib.postRequest("strapiDatabase","it-tickets",token,ticketData);
        } catch (err) {
          console.error("Ticket submission failed:", err);
          this.errorMsg =
            err.response?.data?.error?.message ||
            "Unable to submit ticket. Pleas try again.";
          throw err;
        }

        // ---- Step 3: Notify users ----
        this.notifyUsers(ticketSubmission, fileIds, issue, description);
 

        // ---- Step 4: Reset UI ----
        this.p1 = true;
        await this.resetData();
        await this.populateTicketData();
      } catch (err) {
         if (err.response?.status === 401) {
            this.errorMsg = "Your session has expired. Please log in again.";
            this.p2 = true;
            return;
          }

          this.errorMsg = err.response?.data?.error?.message || "Ticket Submission Failed";
          this.p2 = true;
          console.error("Ticket submission failed:", err);
          return;
      } finally {
        this.submitProcessing = false;
        window.scroll({ top: 0, behavior: "smooth" });
      }
    },
    setIssue: function(value){
      this.issue = value;
    },

    notifyUsers: async function(ticket_submission, fileIds, issue, description){
      let token = this.$store.getters.getToken;
      try{
        await sendEmail([this.emailSubmit, "support@quadruscorp.com"], "Support Ticket Submitted", "A new Support ticket has been submitted.<br>Name: "+ this.nameSubmit 
        + "<br>Issue: " + issue + "<br>Description: " + description, token, "SubmittedTicket&id=" + ticket_submission.data.data.id, fileIds);
      } catch(error){
        console.log(error);
      }
    },

    setFields: async function() {
      let dateObj = new Date();
      let month = dateObj.getUTCMonth() + 1
      let date = dateObj.getUTCDate()
      this.dateOpenedDisplay = dateObj.getFullYear() + "-" + ("0" + month).slice(-2) + "-" + ("0" + date).slice(-2);
      this.dateOpened = new Date().toISOString();
      this.nameSubmit = await this.getLoggedInUser();
      this.emailSubmit = this.$store.getters.getEmail;
      this.populateTicketData();
    },

    populateTicketData: async function() {
      this.isSetUp = false;
      let token = this.$store.getters.getToken;
      var query = '';

      try {
        if(this.showResolved) {
          query = "filters[resolved][$eq][0]="+true + "&populate[1]=imagesOfIssue&populate[2]=userAssigned";
        } else {
          query = "filters[resolved][$eq][0]="+false + "&populate[1]=imagesOfIssue&populate[2]=userAssigned";
        }
        this.ticketData.rowData = [];
        let response = '';

        response = await DatabaseLib.getRequest('strapiDatabase','it-tickets',token,query);
        for(let i = 0; i < response.data.data.length; i = i + 1) {
          if(response.data.data[i].attributes.nameSubmit == this.nameSubmit){
            this.ticketData.rowData.push({
              id: response.data.data[i].id,
              subject: response.data.data[i].attributes.subject,
              priority: response.data.data[i].attributes.priority,
              resolved: response.data.data[i].attributes.resolved? "Yes": "No",
              assignedTo: response.data.data[i].attributes.userAssigned.data ? response.data.data[i].attributes.userAssigned.data.attributes.firstName + " " + response.data.data[i].attributes.userAssigned.data.attributes.lastName : null,
              description: response.data.data[i].attributes.description,
              openDate: response.data.data[i].attributes.openDate,
              openDateDisplay: formatDate(response.data.data[i].attributes.openDate),
            }) 
          }
        }
        this.isSetUp = true;
      } catch(error) {
        this.isSetUp = true;
        window.scroll({top: 0, behavior: 'smooth'});
        this.p5 = true;
        return;
      }
    },

    checkPage: function(){
      if(this.$route.name == "TicketStatus"){
        this.$refs.ticketStatus.scrollIntoView({behavior: 'smooth'})
      } else {
        window.scroll({top: 0, behavior: 'smooth'});
      }
    }
  },
  watch: {
    showResolved: function() {
      this.populateTicketData();
    }
  },
  mounted() {
    this.setFields();
    setTimeout(this.checkPage,1000);    
  }


}
</script>